module.exports = __webpack_public_path__ + "static/img/1_1_2.702b212a.jpg";